<script setup>
import { computed, useTemplateRef } from 'vue';
import Icon from "../Common/Icon.vue";
import { RouterLink } from 'vue-router';

const props = defineProps({
    steps: Array,
});

const indicator = useTemplateRef('indicator');
const container = useTemplateRef('container');

const maxSteps = computed(() => {
    return props.steps.length;
})

const progress = computed(() => {
    for (let i = 0; i < maxSteps.value; i++) {
        if(props.steps[i] === null){
            return i - 1;
        }
    }

    return maxSteps.value;
})

const indicatorOffset = computed(() => {
    if(progress.value < 1){
        return '-10px';
    }

    const indicatorWidth = indicator.value?.getBoundingClientRect().width;
    const progressBarWidth = container.value?.getBoundingClientRect().width;

    if(progress.value === maxSteps.value){
        return (progressBarWidth - indicatorWidth + 10) + 'px'
    }

    return (progressBarWidth * ((progress.value)/(maxSteps.value - 1))) - (indicatorWidth / 2) + 'px';
})

</script>

<template>
    <div ref="container" class="relative flex items-center text-gray-800">
        <div class="contents" v-for="(step, i) in props.steps">
            <div v-if="i > 0">
                <div
                    class="h-px w-32 xl:w-40 4k:w-80 transition-colors"
                    :class="step !== null ? 'bg-secondary shadow-progress-line delay-300' : 'bg-gray-900'"
                ></div>
            </div>
            <div
                class="relative rounded-full size-9 4k:size-12 transition"
                :class="step !== null ? 'bg-secondary hover:scale-110 delay-300' : 'bg-gray-900'"

            >
                <component
                    :to="step"
                    :is="(step === null || step === true) ? 'div' : RouterLink"
                    class="size-full grid place-items-center"
                >
                    <Icon class="size-3 4k:size-5 text-gray-900" name="check"/>
                </component>
            </div>
        </div>

        <div class="pointer-events-none w-36 h-10 4k:w-48 4k:h-16 absolute left-0 top-1/2 -translate-y-1/2">
            <img
                class="size-full transition-transform duration-500"
                src="/bundles/salestool/assets/images/progress_indicator.png"
                :style="{transform: `translateX(${indicatorOffset})`}"
                ref="indicator"
            >
        </div>
    </div>
</template>
